'use client';

import { RadioGroup } from '@headlessui/react';
import { BDRoundedRadio } from '@shared/components/elements/bd-gold-radio';
import BDImage from '@shared/components/elements/bd-image';
import BDButton from '@shared/components/elements/button';
import customDesignImage from '@shared/public/images/get-to-know/custom_design.png';
import haloPendantImage from '@shared/public/images/pendants/halo_pendant.jpg';
import twistedImage from '@shared/public/images/ring/twisted_shank.jpg';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

const productTypes = [
  {
    name: 'Rings',
    image: twistedImage,
    value: 'engagement_rings',
  },
  {
    name: 'Pendants',
    image: haloPendantImage,
    value: 'pendants',
  },
  // {
  //   name: 'Diamond Only',
  //   image: noJewelryImage,
  //   value: 'no_jewelry'
  // },
  {
    name: 'Custom Design',
    image: customDesignImage,
    value: 'custom_design',
  },
];

export default function JewelryCategorySelector({
  searchParams,
  productType,
  isFirstTimeOrder,
}: {
  searchParams: URLSearchParams;
  productType: string;
  isFirstTimeOrder: boolean;
}) {
  const router = useRouter();
  const [selectedProductType, setSelectedProductType] = useState(productType);

  const handleProductTypeChange = (value: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('productType', value);
    setSelectedProductType(value);
    router.push(`?${newSearchParams.toString()}`, { scroll: false });
  };

  return (
    <>
      {/* <BDSubtitle>{isFirstTimeOrder ? 'Browse' : 'Shop'} by Jewelry Category</BDSubtitle> */}
      <form>
        <RadioGroup
          name="category"
          className="mx-auto grid max-w-sm grid-cols-3 gap-6 md:max-w-xl"
          defaultValue={productType}
          onChange={handleProductTypeChange}
        >
          {productTypes.map((productType) => (
            <BDRoundedRadio
              image={
                <BDImage
                  src={productType.image}
                  alt={'Engagement Rings Image'}
                  className="aspect-square w-full scale-75 rounded-full object-cover"
                />
              }
              key={productType.value}
              value={productType.value}
            >
              <p className="mt-4 text-center text-sm">{productType.name}</p>
            </BDRoundedRadio>
          ))}
        </RadioGroup>
      </form>
      {selectedProductType === 'no_jewelry' && (
        <div className="mx-auto mt-4 flex max-w-xl flex-col items-center gap-y-2">
          <p className="text-sm">
            If you only want to purchase your Bonded Diamond™, you can skip the jewelry selection
            and continue. We will set your Bonded Diamond™ in a beautiful diamond box for you.
          </p>
          <BDButton styleType="primary" href="/shop/confirmation" className="mt-4 px-4 py-2">
            Skip Jewelry Selection
          </BDButton>
        </div>
      )}
      {selectedProductType === 'custom_design' && (
        <div className="mx-auto mt-4 flex max-w-xl flex-col items-center gap-y-2">
          <p className="text-sm">
            If your ideal jewelry piece is not listed here, we would love to work with you to check
            your design and give you a free quote. Select this option and our customer service team
            will be in touch with you shortly.
          </p>
          <BDButton styleType="primary" href="/shop/confirmation" className="mt-4 px-4 py-2">
            Continue to the Confirmation
          </BDButton>
        </div>
      )}
    </>
  );
}
